import { Skeleton } from "@baluu/ui/components/skeleton";
import { Button } from "@baluu/ui/components/button";

/** A handful of skeleton rows shown while a tab's query is still pending. */
export function TabSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="space-y-3" aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="h-16 w-full rounded-lg" />
      ))}
    </div>
  );
}

/** Shared "couldn't load" state — every data-fetching tab renders this on error. */
export function TabError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="rounded-lg border bg-muted/30 p-8 text-center space-y-3">
      <p className="text-sm text-muted-foreground">Couldn&apos;t load this section.</p>
      <Button variant="outline" size="sm" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}
